import { render } from "./CircleProgress.vue?vue&type=template&id=77892594"
const script = {}

import "./CircleProgress.vue?vue&type=style&index=0&id=77892594&lang=css"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__